import { TagService } from './tag.service'
import { Project } from './project'
import { DbRecord } from './db-record'

export class Tag {
  isNew: boolean
  private _title: string
  taggedItems = new Set<string>()

  constructor(
    private tags: TagService,
    public project: Project,
    public id: string,
    title: string,
    taggedItemsLs?: string[]
  ) {
    this._title = title
    this.isNew = title == ''

    if (this.id.startsWith('_'))
      return
    this.project.tagsMap.set(this.id, this)

    if (taggedItemsLs)
      this.taggedItems = new Set<string>(taggedItemsLs)
  }

  get seed() {
    let ls = []
    this.taggedItems.forEach(x => ls.push(x))
    return {title: this.title, items:ls}
  }

  set title(txt) {
    this._title = txt.trim()
  }

  get title() {
    return this._title
  }

  switch(dbRecord: DbRecord) {
    if (!this.taggedItems.delete(dbRecord.id))
      this.taggedItems.add(dbRecord.id)
    this.tags.save(this)
  }

  isSelected(dbRecord: DbRecord) {
    return this.taggedItems.has(dbRecord.id)
  }

}



// WEBPACK FOOTER //
// ./src/app/tag.ts